import React, { useState } from 'react';
import { LayoutGrid, Zap, ShoppingCart, ChevronRight, UserPlus, LogOut } from 'lucide-react';
import { View } from '../App';
import { Tribe } from '../data';
import { useAuth } from '../context/AuthContext';
import PermissionGate from './auth/PermissionGate';
import InviteModal from './auth/InviteModal';

interface Props {
  view:    View;
  setView: (v: View) => void;
  tribes:  Tribe[];
  cycle:   string;
  isDirty: boolean;
}

const icons: Record<string, React.ReactNode> = {
  cloud: <Zap size={16} />,
  erp:   <ShoppingCart size={16} />,
};

const ROLE_LABELS: Record<string, string> = {
  viewer: 'Visualizador',
  editor: 'Editor',
  admin:  'Admin',
};

export default function Sidebar({ view, setView, tribes, cycle, isDirty }: Props) {
  const { user, logout } = useAuth();
  const [showInvite, setShowInvite] = useState(false);

  return (
    <>
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark">PI</div>
          <div>
            <div className="logo-title">Pedbot</div>
            <div className="logo-sub">Integrações</div>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section-label">Visão geral</div>
          <button
            className={`nav-item ${view === 'org' ? 'active' : ''}`}
            onClick={() => setView('org')}
          >
            <LayoutGrid size={16} />
            <span>Organograma</span>
            {view === 'org' && <ChevronRight size={14} className="nav-arrow" />}
          </button>

          <div className="nav-section-label">Tribos</div>
          {tribes.map(tribe => (
            <button
              key={tribe.id}
              className={`nav-item ${view === tribe.id ? 'active' : ''} tribe-${tribe.color}`}
              onClick={() => setView(tribe.id as View)}
            >
              {icons[tribe.id]}
              <span>{tribe.id === 'cloud' ? 'Cloud API' : 'Gestão de Pedidos'}</span>
              {view === tribe.id && <ChevronRight size={14} className="nav-arrow" />}
            </button>
          ))}

          <PermissionGate required="admin">
            <div className="nav-section-label">Acesso</div>
            <button
              className="nav-item"
              onClick={() => setShowInvite(true)}
            >
              <UserPlus size={16} />
              <span>Convidar pessoa</span>
            </button>
          </PermissionGate>
        </nav>

        <div className="sidebar-user">
          <div className="sidebar-user-email">{user?.email}</div>
          <div className="sidebar-user-row">
            <span className={`sidebar-role-badge ${user?.role}`}>
              {user ? ROLE_LABELS[user.role] : ''}
            </span>
            <button className="sidebar-logout-btn" onClick={logout}>
              <LogOut size={12} />
              Sair
            </button>
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="footer-label">Ciclo atual</div>
          <div className="footer-cycle">{cycle}</div>
          {isDirty && <div className="footer-dirty">● não salvo</div>}
        </div>
      </aside>

      {showInvite && <InviteModal onClose={() => setShowInvite(false)} />}
    </>
  );
}
